/**
 * Extended Product List – filters, sort, pagination (URL via browser; Liquid cannot read query params)
 */
(function () {
  'use strict';

  function selectVariant(card, swatch) {
    const variantId = swatch.getAttribute('data-variant-id');
    const imageUrl = swatch.getAttribute('data-variant-image');
    const productUrl = swatch.getAttribute('data-variant-url');
    const priceFormatted = swatch.getAttribute('data-variant-price-formatted');
    const compareFormatted = swatch.getAttribute('data-variant-compare-formatted');
    const saveLabel = swatch.getAttribute('data-variant-save-label');
    const savePercent = swatch.getAttribute('data-variant-save-percent');
    const available = swatch.getAttribute('data-variant-available') === 'true';

    card.querySelectorAll('[data-frr-swatch]').forEach((btn) => {
      btn.classList.toggle('is-active', btn === swatch);
    });

    const input = card.querySelector('[data-frr-variant-input]');
    if (input && variantId) input.value = variantId;

    const wishlist = card.querySelector('[data-frr-wishlist]');
    if (wishlist && variantId) wishlist.setAttribute('data-variant-id', variantId);

    const image = card.querySelector('[data-frr-image]');
    if (image && imageUrl) {
      image.src = imageUrl;
      image.removeAttribute('srcset');
    }

    const imageLink = card.querySelector('[data-frr-image-link]');
    const titleLink = card.querySelector('[data-frr-title-link]');
    if (productUrl) {
      if (imageLink) imageLink.href = productUrl;
      if (titleLink) titleLink.href = productUrl;
    }

    const priceEl = card.querySelector('[data-frr-price]');
    if (priceEl && priceFormatted) priceEl.textContent = priceFormatted;

    const compareEl = card.querySelector('[data-frr-compare]');
    if (compareEl) {
      if (compareFormatted) {
        compareEl.textContent = compareFormatted;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    const saveBadge = card.querySelector('[data-frr-save-badge]');
    const saveLabelEl = card.querySelector('[data-frr-save-label]');
    const savePercentEl = card.querySelector('[data-frr-save-percent]');
    const offerEl = card.querySelector('[data-frr-offer]');

    if (saveBadge && saveLabelEl && savePercentEl) {
      if (saveLabel && savePercent) {
        saveLabelEl.textContent = saveLabel;
        savePercentEl.textContent = savePercent;
        saveBadge.hidden = false;
        if (offerEl) offerEl.hidden = false;
      } else {
        saveBadge.hidden = true;
        if (offerEl) offerEl.hidden = true;
      }
    }

    const atc = card.querySelector('[data-frr-atc]');
    if (atc) {
      const labelEl = getAtcLabel(atc);
      atc.disabled = !available;
      if (labelEl) {
        labelEl.textContent = available
          ? labelEl.dataset.frrAtcDefault || 'Add to Cart'
          : 'Sold Out';
      }
    }
  }

  function getAtcLabel(atc) {
    return atc.querySelector('staged-action-text') || atc;
  }

  function initCards(root) {
    root.querySelectorAll('[data-frr-card]').forEach((card) => {
      if (card.dataset.frrCardReady === 'true') return;
      card.dataset.frrCardReady = 'true';
      card.querySelectorAll('[data-frr-swatch]').forEach((swatch) => {
        swatch.addEventListener('click', () => selectVariant(card, swatch));
      });
      const atc = card.querySelector('[data-frr-atc]');
      if (atc) {
        const labelEl = getAtcLabel(atc);
        if (labelEl && !labelEl.dataset.frrAtcDefault) {
          labelEl.dataset.frrAtcDefault = labelEl.textContent.trim();
        }
      }
    });
  }

  function formatMoney(cents, format) {
    if (!format) return String(cents / 100);
    const value = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  function getUrlFilters() {
    const params = new URLSearchParams(window.location.search);
    return {
      age: params.get('epl_age') || '',
      voltage: params.get('epl_voltage') || '',
      type: params.get('epl_type') || '',
      priceMin: parseInt(params.get('epl_price_min') || '0', 10) || 0,
      priceMax: parseInt(params.get('epl_price_max') || '0', 10) || 0,
      page: Math.max(1, parseInt(params.get('epl_page') || '1', 10) || 1),
      sortBy: params.get('sort_by') || '',
    };
  }

  function buildUrl(filters) {
    const params = new URLSearchParams();
    if (filters.age) params.set('epl_age', filters.age);
    if (filters.voltage) params.set('epl_voltage', filters.voltage);
    if (filters.type) params.set('epl_type', filters.type);
    if (filters.priceMin > 0) params.set('epl_price_min', String(filters.priceMin));
    if (filters.priceMax > 0) params.set('epl_price_max', String(filters.priceMax));
    if (filters.sortBy) params.set('sort_by', filters.sortBy);
    if (filters.page > 1) params.set('epl_page', String(filters.page));
    const qs = params.toString();
    const path = window.location.pathname;
    return qs ? `${path}?${qs}` : path;
  }

  function getFiltersFromForm(form, root) {
    const ageEl = form.querySelector('[name="epl_age"]');
    const voltEl = form.querySelector('[name="epl_voltage"]');
    const typeEl = form.querySelector('[name="epl_type"]');
    const minEl = form.querySelector('[name="epl_price_min"]');
    const maxEl = form.querySelector('[name="epl_price_max"]');
    const sortEl = root?.querySelector('[data-epl-sort]:not([disabled])') || form.querySelector('[data-epl-sort]');

    return {
      age: ageEl ? ageEl.value : '',
      voltage: voltEl ? voltEl.value : '',
      type: typeEl ? typeEl.value : '',
      priceMin: minEl ? parseInt(minEl.value, 10) || 0 : 0,
      priceMax: maxEl ? parseInt(maxEl.value, 10) || 0 : 0,
      page: 1,
      sortBy: sortEl ? sortEl.value : getUrlFilters().sortBy,
    };
  }

  function itemMatches(item, filters) {
    if (filters.age && item.dataset.age !== filters.age) return false;
    if (filters.voltage && item.dataset.voltage !== filters.voltage) return false;

    if (filters.type) {
      const cols = (item.dataset.collections || '').split(',').filter(Boolean);
      if (!cols.includes(filters.type)) return false;
    }

    const price = parseInt(item.dataset.price, 10) || 0;
    if (filters.priceMin > 0 && price < filters.priceMin) return false;
    if (filters.priceMax > 0 && price > filters.priceMax) return false;

    return true;
  }

  function sortItems(items, sortBy) {
    const list = [...items];
    if (!sortBy) return list;

    list.sort((a, b) => {
      const priceA = parseInt(a.dataset.price, 10) || 0;
      const priceB = parseInt(b.dataset.price, 10) || 0;
      const titleA = (a.dataset.title || '').toLowerCase();
      const titleB = (b.dataset.title || '').toLowerCase();

      switch (sortBy) {
        case 'price-ascending':
          return priceA - priceB;
        case 'price-descending':
          return priceB - priceA;
        case 'title-ascending':
          return titleA.localeCompare(titleB);
        case 'title-descending':
          return titleB.localeCompare(titleA);
        default:
          return 0;
      }
    });

    return list;
  }

  function applyFiltersAndPagination(root) {
    const grid = root.querySelector('[data-epl-grid]');
    const emptyEl = root.querySelector('[data-epl-empty]');
    const paginationEl = root.querySelector('[data-epl-pagination]');
    const countEl = root.querySelector('[data-epl-count-number]');
    const perPage = parseInt(root.dataset.perPage, 10) || 8;

    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('[data-epl-item]'));
    const filters = getUrlFilters();
    const matched = sortItems(items.filter((item) => itemMatches(item, filters)), filters.sortBy);

    const totalPages = Math.max(1, Math.ceil(matched.length / perPage) || 1);
    const page = Math.min(filters.page, totalPages);
    const start = (page - 1) * perPage;

    items.forEach((item) => {
      item.hidden = true;
      item.style.display = 'none';
    });

    matched.forEach((item, index) => {
      const onPage = index >= start && index < start + perPage;
      item.hidden = !onPage;
      item.style.display = onPage ? '' : 'none';
    });

    if (emptyEl) {
      emptyEl.hidden = matched.length > 0;
    }
    grid.hidden = matched.length === 0;

    if (countEl) {
      const count = matched.length;
      const countText = count < 10 ? `0${count}` : String(count);
      countEl.textContent = countText;
      const countMobile = root.querySelector('[data-epl-count-number-mobile]');
      if (countMobile) countMobile.textContent = countText;
    }

    if (paginationEl) {
      renderPagination(paginationEl, page, totalPages, filters);
    }

    grid.classList.add('is-epl-ready');
    syncFormFromUrl(root, filters);
    updateActiveFilters(root, filters);
    updateToolbarClearAll(root, filters);
  }

  function hasActiveEplFilters(filters, catalogMin, catalogMax) {
    const hasPrice =
      (filters.priceMin > 0 && filters.priceMin > catalogMin) ||
      (filters.priceMax > 0 && filters.priceMax < catalogMax);
    return Boolean(filters.age || filters.voltage || filters.type || hasPrice);
  }

  function updateToolbarClearAll(root, filters) {
    const btn = root.querySelector('[data-epl-clear-all]');
    if (!btn) return;
    const catalogMin = parseInt(root.dataset.catalogMin, 10) || 0;
    const catalogMax = parseInt(root.dataset.catalogMax, 10) || 0;
    btn.hidden = !hasActiveEplFilters(filters, catalogMin, catalogMax);
  }

  function updateActiveFilters(root, filters) {
    const container = root.querySelector('[data-epl-active-filters]');
    if (!container) return;

    const catalogMin = parseInt(root.dataset.catalogMin, 10) || 0;
    const catalogMax = parseInt(root.dataset.catalogMax, 10) || 0;
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const collectionUrl = root.dataset.collectionUrl || window.location.pathname;
    const labelAge = root.dataset.labelAge || 'Age';
    const labelVoltage = root.dataset.labelVoltage || 'Voltage';
    const labelType = root.dataset.labelType || 'Type';
    const labelPrice = root.dataset.labelPrice || 'Price';
    const clearLabel = root.dataset.clearFilters || 'Clear All';

    const tags = [];

    if (filters.age) {
      tags.push({
        label: `${labelAge}: ${filters.age}`,
        href: buildUrl({ ...filters, age: '', page: 1 }),
      });
    }

    if (filters.voltage) {
      tags.push({
        label: `${labelVoltage}: ${filters.voltage}`,
        href: buildUrl({ ...filters, voltage: '', page: 1 }),
      });
    }

    if (filters.type) {
      const typeEl = root.querySelector(`[name="epl_type"] option[value="${CSS.escape(filters.type)}"]`);
      const typeName = typeEl ? typeEl.textContent.trim() : filters.type;
      tags.push({
        label: `${labelType}: ${typeName}`,
        href: buildUrl({ ...filters, type: '', page: 1 }),
      });
    }

    const hasPriceFilter =
      (filters.priceMin > 0 && filters.priceMin > catalogMin) ||
      (filters.priceMax > 0 && filters.priceMax < catalogMax);

    if (hasPriceFilter) {
      const minDisplay = filters.priceMin > 0 ? filters.priceMin : catalogMin;
      const maxDisplay = filters.priceMax > 0 ? filters.priceMax : catalogMax;
      tags.push({
        label: `${labelPrice}: ${formatMoney(minDisplay, moneyFormat)} – ${formatMoney(maxDisplay, moneyFormat)}`,
        href: buildUrl({ ...filters, priceMin: 0, priceMax: 0, page: 1 }),
      });
    }

    if (tags.length === 0) {
      container.hidden = true;
      container.innerHTML = '';
      return;
    }

    container.hidden = false;
    let html = '<ul class="epl__active-list">';
    tags.forEach((tag) => {
      html += `<li><a href="${tag.href}" class="epl__active-tag" data-epl-remove-filter>${tag.label}<span aria-hidden="true">×</span></a></li>`;
    });
    html += `</ul><a href="${collectionUrl}" class="epl__clear-filters">${clearLabel}</a>`;
    container.innerHTML = html;
  }

  function syncFormFromUrl(root, filters) {
    const form = root.querySelector('[data-epl-filter-form]');
    if (!form) return;

    const ageEl = form.querySelector('[name="epl_age"]');
    const voltEl = form.querySelector('[name="epl_voltage"]');
    const typeEl = form.querySelector('[name="epl_type"]');
    if (ageEl) ageEl.value = filters.age;
    if (voltEl) voltEl.value = filters.voltage;
    if (typeEl) typeEl.value = filters.type;
    if (filters.sortBy) syncSortSelects(root, filters.sortBy);
  }

  function renderPagination(container, page, totalPages, filters) {
    if (totalPages <= 1) {
      container.innerHTML = '';
      container.hidden = true;
      return;
    }

    container.hidden = false;
    const baseFilters = { ...filters, page: 1 };
    let html = '<ul class="epl__pagination-list">';

    if (page > 1) {
      html += `<li><a href="${buildUrl({ ...baseFilters, page: page - 1 })}" class="epl__pagination-link epl__pagination-link--prev" data-epl-page-link="${page - 1}" aria-label="Previous page"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
  <path d="M3.76923 8L4.52846 7.19429L2.06231 4.57143H14V3.42857H2.06231L4.53385 0.805714L3.76923 0L0 4L3.76923 8Z" fill="black"/>
</svg> Previous</a></li>`;
    }

    for (let p = 1; p <= totalPages; p += 1) {
      if (p === page) {
        html += `<li><span class="epl__pagination-link is-current" aria-current="page">${p}</span></li>`;
      } else {
        html += `<li><a href="${buildUrl({ ...baseFilters, page: p })}" class="epl__pagination-link" data-epl-page-link="${p}">${p}</a></li>`;
      }
    }

    if (page < totalPages) {
      html += `<li><a href="${buildUrl({ ...baseFilters, page: page + 1 })}" class="epl__pagination-link epl__pagination-link--next" data-epl-page-link="${page + 1}" aria-label="Next page">Next <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
  <path d="M10.2308 0L9.47154 0.805714L11.9377 3.42857L-9.53674e-07 3.42857V4.57143L11.9377 4.57143L9.46615 7.19429L10.2308 8L14 4L10.2308 0Z" fill="black"/>
</svg></a></li>`;
    }

    html += '</ul>';
    container.innerHTML = html;
  }

  function navigate(filters) {
    window.location.href = buildUrl(filters);
  }

  function isMobileEpl() {
    return window.matchMedia('(max-width: 1280px)').matches;
  }

  function syncSortSelects(root, value) {
    root.querySelectorAll('[data-epl-sort]').forEach((select) => {
      if (select.value !== value) select.value = value;
    });
  }

  function initAutoFilters(form, root) {
    form.querySelectorAll('[data-epl-filter-auto]').forEach((select) => {
      if (select.dataset.eplAutoReady === 'true') return;
      select.dataset.eplAutoReady = 'true';
      select.addEventListener('change', () => {
        if (isMobileEpl()) return;
        const filters = getFiltersFromForm(form, root);
        navigate(filters);
      });
    });
  }

  function initSort(root, form) {
    const selects = root.querySelectorAll('[data-epl-sort]');
    if (!selects.length) return;

    selects.forEach((select) => {
      if (select.dataset.eplSortReady === 'true') return;
      select.dataset.eplSortReady = 'true';
      select.addEventListener('change', () => {
        syncSortSelects(root, select.value);
        const filters = getFiltersFromForm(form, root);
        filters.sortBy = select.value;
        navigate(filters);
      });
    });
  }

  function getAccordionIcon(name) {
    const icons = {
      calendar:
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="5" width="18" height="16" rx="2" stroke="currentColor" stroke-width="1.6"/><path d="M8 3v4M16 3v4M3 10h18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
      grid:
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="4" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="4" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.6"/><rect x="4" y="14" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="14" width="6" height="6" rx="1" stroke="currentColor" stroke-width="1.6"/></svg>',
      voltage:
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
      price:
        '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 7h8a3 3 0 110 6H9a3 3 0 100 6h8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M12 4v16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    };
    return icons[name] || icons.grid;
  }

  function initMobileFilterDrawer(root, form) {
    const drawer = root.querySelector('[data-epl-mobile-drawer]');
    const drawerBody = root.querySelector('[data-epl-drawer-filters]');
    const filtersHost = form.querySelector('[data-epl-toolbar-filters]');
    if (!drawer || !drawerBody || !filtersHost || drawer.dataset.eplDrawerReady === 'true') return;

    drawer.dataset.eplDrawerReady = 'true';

    const mobileQuery = window.matchMedia('(max-width: 1280px)');
    const filterItems = Array.from(filtersHost.querySelectorAll(':scope > .epl__filter'));
    const accordionMeta = [
      { match: '[name="epl_age"]', label: root.dataset.mobileLabelAge || 'Age Range', icon: 'calendar' },
      { match: '[name="epl_type"]', label: root.dataset.mobileLabelType || 'By Type', icon: 'grid' },
      { match: '[name="epl_voltage"]', label: root.dataset.mobileLabelVoltage || 'By Voltage', icon: 'voltage' },
      { match: '[data-epl-price-details]', label: root.dataset.mobileLabelPrice || 'Price Range', icon: 'price' },
    ];

    let mountedMobile = false;

    function preparePriceFilterForMobile(filterEl) {
      const priceDetails = filterEl.querySelector('[data-epl-price-details]');
      if (!priceDetails) return;
      priceDetails.setAttribute('open', '');
      priceDetails.classList.add('epl__price-details--mobile');
    }

    function restorePriceFilterForDesktop(filterEl) {
      const priceDetails = filterEl.querySelector('[data-epl-price-details]');
      if (!priceDetails) return;
      priceDetails.removeAttribute('open');
      priceDetails.classList.remove('epl__price-details--mobile');
    }

    function restoreDesktopFilters() {
      filterItems.forEach((filterEl) => {
        restorePriceFilterForDesktop(filterEl);
        filtersHost.appendChild(filterEl);
      });
      drawerBody.innerHTML = '';
      mountedMobile = false;
    }

    function mountMobileFilters() {
      if (!mobileQuery.matches) {
        restoreDesktopFilters();
        return;
      }
      if (mountedMobile) return;

      drawerBody.innerHTML = '';
      accordionMeta.forEach((meta) => {
        const filterEl = filterItems.find((el) => el.querySelector(meta.match));
        if (!filterEl) return;

        const accordion = document.createElement('details');
        accordion.className = 'epl__mobile-accordion';
        accordion.innerHTML = `
          <summary class="epl__mobile-accordion__summary">
            <span class="epl__mobile-accordion__icon">${getAccordionIcon(meta.icon)}</span>
            <span class="epl__mobile-accordion__label">${meta.label}</span>
            <span class="epl__mobile-accordion__chevron" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" height="18" width="18">
                <path d="M8.110423828124999 13.670279296875c0.492022265625 0.492022265625 1.291067578125 0.492022265625 1.78308984375 0l7.55746875 -7.55746875c0.492022265625 -0.492022265625 0.492022265625 -1.291067578125 0 -1.78308984375s-1.291067578125 -0.492022265625 -1.78308984375 0L9 10.99761328125 2.332107421875 4.3336546875c-0.492022265625 -0.492022265625 -1.291067578125 -0.492022265625 -1.78308984375 0s-0.492022265625 1.291067578125 0 1.783093359375l7.55746875 7.55746875Z" fill="#5f5f5f" stroke-width="0.0352"></path>
              </svg>
            </span>
          </summary>
          <div class="epl__mobile-accordion__panel"></div>
        `;
        accordion.querySelector('.epl__mobile-accordion__panel').appendChild(filterEl);
        if (meta.match === '[data-epl-price-details]') {
          preparePriceFilterForMobile(filterEl);
        }
        drawerBody.appendChild(accordion);
      });

      mountedMobile = true;
    }

    function openDrawer() {
      mountMobileFilters();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('epl-mobile-drawer-open');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('epl-mobile-drawer-open');
    }

    root.querySelector('[data-epl-filter-open]')?.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-epl-filter-close]').forEach((btn) => {
      btn.addEventListener('click', closeDrawer);
    });

    drawer.querySelector('[data-epl-mobile-apply]')?.addEventListener('click', () => {
      const details = root.querySelector('[data-epl-price-details]');
      const minRange = details?.querySelector('[data-epl-price-min-range]');
      const maxRange = details?.querySelector('[data-epl-price-max-range]');
      const minInput = details?.querySelector('[data-epl-price-min-input]');
      const maxInput = details?.querySelector('[data-epl-price-max-input]');
      const catalogMin = parseInt(root.dataset.catalogMin, 10) || 0;
      const catalogMax = parseInt(root.dataset.catalogMax, 10) || 0;

      if (minRange && maxRange && minInput && maxInput) {
        const minVal = parseInt(minRange.value, 10);
        const maxVal = parseInt(maxRange.value, 10);
        if (minVal <= catalogMin && maxVal >= catalogMax) {
          minInput.value = '0';
          maxInput.value = '0';
        } else {
          minInput.value = String(minVal);
          maxInput.value = String(maxVal);
        }
      }

      navigate(getFiltersFromForm(form, root));
      closeDrawer();
    });

    drawer.querySelector('[data-epl-mobile-reset]')?.addEventListener('click', () => {
      const collectionUrl = root.dataset.collectionUrl || window.location.pathname;
      window.location.href = collectionUrl;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    mobileQuery.addEventListener('change', () => {
      if (!mobileQuery.matches) closeDrawer();
      mountMobileFilters();
    });

    mountMobileFilters();
  }

  function initPriceFilter(root, form) {
    const details = root.querySelector('[data-epl-price-details]');
    if (!details || details.dataset.eplPriceReady === 'true') return;

    const minRange = details.querySelector('[data-epl-price-min-range]');
    const maxRange = details.querySelector('[data-epl-price-max-range]');
    const minInput = details.querySelector('[data-epl-price-min-input]');
    const maxInput = details.querySelector('[data-epl-price-max-input]');
    const minLabel = details.querySelector('[data-epl-price-min-label]');
    const maxLabel = details.querySelector('[data-epl-price-max-label]');
    const applyBtn = details.querySelector('[data-epl-price-apply]');
    const summary = root.querySelector('[data-epl-price-summary]');

    if (!minRange || !maxRange || !minInput || !maxInput) return;

    const catalogMin = parseInt(root.dataset.catalogMin, 10) || 0;
    const catalogMax = parseInt(root.dataset.catalogMax, 10) || 0;
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    details.dataset.eplPriceReady = 'true';

    const urlFilters = getUrlFilters();
    if (urlFilters.priceMin > 0) {
      minRange.value = String(urlFilters.priceMin);
      minInput.value = String(urlFilters.priceMin);
    }
    if (urlFilters.priceMax > 0) {
      maxRange.value = String(urlFilters.priceMax);
      maxInput.value = String(urlFilters.priceMax);
    }

    function syncLabels() {
      let minVal = parseInt(minRange.value, 10);
      let maxVal = parseInt(maxRange.value, 10);
      if (minVal > maxVal) {
        if (document.activeElement === minRange) {
          maxVal = minVal;
          maxRange.value = String(maxVal);
        } else {
          minVal = maxVal;
          minRange.value = String(minVal);
        }
      }
      if (minLabel) minLabel.textContent = formatMoney(minVal, moneyFormat);
      if (maxLabel) maxLabel.textContent = formatMoney(maxVal, moneyFormat);
    }

    minRange.addEventListener('input', syncLabels);
    maxRange.addEventListener('input', syncLabels);
    syncLabels();

    if (applyBtn) {
      applyBtn.addEventListener('click', () => {
        if (isMobileEpl()) return;

        const minVal = parseInt(minRange.value, 10);
        const maxVal = parseInt(maxRange.value, 10);
        const filters = getFiltersFromForm(form, root);

        if (minVal <= catalogMin && maxVal >= catalogMax) {
          filters.priceMin = 0;
          filters.priceMax = 0;
          minInput.value = '0';
          maxInput.value = '0';
        } else {
          filters.priceMin = minVal;
          filters.priceMax = maxVal;
          minInput.value = String(minVal);
          maxInput.value = String(maxVal);
          if (summary) {
            summary.textContent = `${formatMoney(minVal, moneyFormat)} – ${formatMoney(maxVal, moneyFormat)}`;
          }
        }

        navigate(filters);
      });
    }
  }

  function initPaginationClicks(root) {
    root.addEventListener('click', (event) => {
      const pageLink = event.target.closest('[data-epl-page-link]');
      if (pageLink) {
        event.preventDefault();
        const page = parseInt(pageLink.getAttribute('data-epl-page-link'), 10) || 1;
        const filters = getUrlFilters();
        filters.page = page;
        navigate(filters);
        return;
      }

      const removeLink = event.target.closest('[data-epl-remove-filter]');
      if (removeLink) {
        event.preventDefault();
        window.location.href = removeLink.getAttribute('href');
        return;
      }

      const clearAll = event.target.closest('[data-epl-clear-all]');
      if (clearAll) {
        event.preventDefault();
        const collectionUrl = root.dataset.collectionUrl || window.location.pathname;
        window.location.href = collectionUrl;
      }
    });
  }

  function initFormSubmit(form, root) {
    if (form.dataset.eplSubmitReady === 'true') return;
    form.dataset.eplSubmitReady = 'true';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      navigate(getFiltersFromForm(form, root));
    });
  }

  function initSection(sectionEl) {
    const root = sectionEl.querySelector('[data-extended-product-list]');
    if (!root || root.dataset.eplReady === 'true') return;
    root.dataset.eplReady = 'true';

    const form = root.querySelector('[data-epl-filter-form]');
    if (form) {
      initFormSubmit(form, root);
      initAutoFilters(form, root);
      initSort(root, form);
      initPriceFilter(root, form);
      initMobileFilterDrawer(root, form);
    }

    initPaginationClicks(root);
    initCards(root);
    applyFiltersAndPagination(root);
  }

  function initAll() {
    document.querySelectorAll('.extended-product-list-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('extended-product-list-section')) {
      const root = event.target.querySelector('[data-extended-product-list]');
      if (root) root.dataset.eplReady = 'false';
      initSection(event.target);
    }
  });
})();
(function(){
  var HIDE = ['title-ascending','title-descending','created-ascending','created-descending'];
  var pending = false;
  function strip(){
    pending = false;
    document.querySelectorAll('.epl__sort-select option, .epl__mobile-sort-select option').forEach(function(o){
      if (HIDE.indexOf(o.value) > -1) o.remove();
    });
  }
  function queue(){
    if (pending) return;
    pending = true;
    requestAnimationFrame(strip);
  }
  strip();
  document.addEventListener('DOMContentLoaded', strip);
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();